import React from 'react';
import Header from '../header';
import Footer from '../footer';
import UnderConstruction from '../underConstruction';

const HowToHelpPage = () => {
    return (
        <div>
            <Header />
            <UnderConstruction />
            <Footer />
        </div>
    )
}

export default HowToHelpPage;